import { setInbox } from 'store/reducer/mainSlice';
import { apiSlice } from '../api/apiSlice';
import { getRoleMenu, setModuleMenuMap } from './menuSlice';

export const menuApi = apiSlice.injectEndpoints({
	tagTypes: ['Menu'],
	endpoints: (builder) => ({
		getMenu: builder.mutation({
			query: (data) => ({
				url: '/authorization-service/endpoint/rolemenu/roleId',
				method: 'POST',
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const res = await queryFulfilled;
					dispatch(
						getRoleMenu({
							type: 'initial',
							menuItems: res.data.result.response[0].menuId,
							menuNotification: {},
						})
					);
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		getMenuQ: builder.query({
			query: () => ({
				url: '/authorization-service/endpoint/rolemenu/roleIdGet',
				method: 'GET',
				validateStatus: (response, result) => response.status === 200 && result?.result?.status === 'SUCCESS',
			}),
			providesTags: ['Menu'],
			refetchOnMountOrArgChange: false,
			refetchOnReconnect: false,
			refetchOnFocus: false,
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const res = await queryFulfilled;

					console.log('res', res);
					// dispatch(
					// 	getRoleMenu({
					// 		type: 'initial',
					// 		menuItems: res.data.result.response[0].menuId,
					// 		menuNotification: {},
					// 	})
					// );
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		getMenuByModule: builder.query({
			query: (selectedModule) => ({
				url: '/authorization-service/endpoint/rolemodulemenu/roleIdGetAllMapByModule',
				method: 'GET',
				validateStatus: (response, result) => response.status === 200 && result?.result?.status === 'SUCCESS',
			}),
			serializeQueryArgs: ({ endpointName }) => endpointName,
			providesTags: ['Menu'],
			refetchOnMountOrArgChange: false,
			refetchOnReconnect: false,
			refetchOnFocus: false,
			async onQueryStarted(arg, { queryFulfilled, dispatch, getState }) {
				try {
					const res = await queryFulfilled;
					const moduleMap = res?.data?.result?.response?.[0] ?? null;

					if (moduleMap && typeof moduleMap === 'object') {
						dispatch(setModuleMenuMap(moduleMap));
					}

					const selectedModule = arg ?? getState()?.menu?.selectedModule ?? 'GLOBAL';
					const moduleEntry = moduleMap && selectedModule ? moduleMap[selectedModule] : null;
					const menuItems = Array.isArray(moduleEntry?.menuId) ? moduleEntry.menuId : [];

					dispatch(
						getRoleMenu({
							type: 'initial',
							menuItems,
							menuNotification: {},
						})
					);
				} catch (error) {
					// console.log(error);
				}
			},
		}),

		// GetAllMenuCount: builder.mutation({
		//   query: (data) => ({
		//     url: "/lynorg-service/endpoint/process/get-workflow-instance-count_by-filter",
		//     method: "POST",
		//     body: data,
		//   }),
		//   async onQueryStarted(args, { queryFulfilled, dispatch, getState }) {
		//     try {
		//       const response = await queryFulfilled;
		//       const arr = response?.data?.lynStageCounting || [];
		//       const menuList = getState()?.menu?.menuItems || [];
		//       const menuNotifications = {};
		//       arr?.forEach((item) => {
		//         let key = item?.box?.toLowerCase();
		//         menuNotifications[key] = item;
		//       });

		//       dispatch(
		//         getRoleMenu({
		//           type: "initial",
		//           menuItems: menuList,
		//           menuNotification: menuNotifications,
		//         })
		//       );
		//     } catch (error) {
		//       console.log(error);
		//     }
		//   },
		// }),

		getModule: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-module-company-menu',
				method: 'POST',
				body: data,
			}),
		}),
		getMenuCount: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-workflow-instance-count_by-filter-v2',
				method: 'POST',
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch, getState }) {
				try {
					const { menu } = getState();
					const response = await queryFulfilled;
					const arr = response?.data?.lynStageCounting || [];
					const prevMenuNotificationCount = menu?.menuNotification ?? {};
					const caseBox = Object.keys(prevMenuNotificationCount);
					// let currentPage = null;

					// caseBox?.forEach(menuItem => {
					//   if(menu?.openItem[0] === menuItem || menu?.openItem[1] === menuItem) {
					//     currentPage = menuItem;
					//   }
					// });

					const menuNotification = {};

					arr.forEach((item) => {
						let key = item?.box?.toLowerCase();
						menuNotification[key] = item;
					});

					caseBox?.forEach((key) => {
						if (menuNotification[key].count > prevMenuNotificationCount[key].count) {
							if (menu?.openItem?.[0] === key || menu?.openItem?.[1] === key) {
								dispatch(
									setInbox({
										[key]: menuNotification[key].count,
									})
								);
							}
						}
					});

					dispatch(
						getRoleMenu({
							type: 'updateCount',
							menuNotification: menuNotification,
						})
					);
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		attendance: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/external/attendance',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.msg?.childStatus === 'SUCCESS';
				},
			}),
		}),
		getModuleInfo: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-module-company-code',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
	}),
});

export const {
	useGetMenuMutation,
	useGetModuleMutation,
	useGetModuleInfoMutation,
	useGetMenuCountMutation,
	useGetMenuQQuery,
	useGetMenuByModuleQuery,
	useAttendanceMutation,
} = menuApi;
